const divActionModalFilter = {
  buttonCancel: 'CANCELAR',
  button: 'APLICAR'
};

export default divActionModalFilter;
